import React from "react";

import UrlIcon from "../icons/call.svg";

const ForSchool = ({actionProvider}) => {
  const options = [
    { text: "⭐ Success Stories", handler: actionProvider.handleBookDemo, id: 1 ,info:'Manage operations, reports, compliance'},
    { text: "📅 Free Consultation", handler: actionProvider.handleBookDemo, id: 2 ,info:'Track student progress, manage classes, and communicate with parents'},
    // { text: "👨‍👩‍👧 Parents", handler: actionProvider.handleBookDemo, id: 3 ,info:'View attendance, assignments, and school notifications'},
    // { text: "✅ Book A Demo", handler: actionProvider.handleBookDemo, id: 7 },

  ];
  return (
    <div className="options">
    <p>👉 Would you like to see success stories or talk to our advisors?</p>
    <div className="options-containerF">
        {options.map((option) => {
          return (
            <>
            <div
              className="option-itemF"
              onClick={option.handler}
              key={option.id}
            >
              {option.text}
              
            </div>
            {/* <p  className="option-itemF-info">{option.info}</p> */}
            </>
          );
        })}
      </div>
      {/* <p>Would you like me to show a <span style={{ fontWeight: 'bold' }}>demo tailored for your role?</span></p>
      <div className="options-containerF">
      <div
              className="option-itemF"
              onClick={actionProvider.handleBookDemo}
              // key={option.id}
            >
              📅 Book a Free Consultation
            </div>
      </div> */}
  </div>
  );
};

export default ForSchool;
